import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'; 
import Paper from '@material-ui/core/Paper';
import { connect } from "react-redux";
import MainWrapper from "../wrappers/MainWrapper";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from "react-router-dom";
import Button from '@material-ui/core/Button'; 
import { reduxForm } from "redux-form";
import validateEmail from "../../utils/validateEmail";
import { fetchTriggered ,checkUserRole,fetchTriggeredCSV} from "../../actions";
import Snackbar from '@material-ui/core/Snackbar';
import NotificationSnackBar from '../../utils/NotificationSnackBar';
import PlusCircleIcon from '@material-ui/icons/AddCircle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import EnhancedTableToolbar from '../../utils/EnhancedTableToolbar'; 
import TriggeredNotifyTable from '../../utils/MainTable/TriggeredNotifyTable'; 
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { CSVLink, CSVDownload } from "react-csv";

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}

const WAIT_INTERVAL = 1000;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height:'100%',
        position: "fixed",
        backgroundColor:'rgba(220,220,220,0.3)',
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        color: "green"
    }
});
class TriggeredNotifications extends React.Component {
    

    constructor(props, context) {
        super(props, context);
        this.state = { 
            open: false,
            isSwitchSnackbarOn: false, 
            page: 0,
            rowsPerPage: 5,
            offset: 0,
            status:'',
            type:'',
            dateFrom: "",
            dateTo:"",
            results:[],
            key:'',
            loading:false,
            contextChanged:true,
            filteredHotspot:{},
            userRoles:{
                userRoles:[],
                error:null
            },
            csv:{
                content:''
            },
            enableCsv:false,
        }; 
        this.props.checkUserRole();
    }

    componentDidMount() { 
        
      if(localStorage.length ==0){
        this.context.router.history.push("/signIn");
      }
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        
        today =yyyy + '-' +mm + '-' + dd ;
            //    this.props.checkfilestatus(today,today );
                this.setState({ loading: false,
                    dateFrom: today,
                    dateTo:today
                 });
    }

   
    static getDerivedStateFromProps(props, state) { 
        let update = {};
        console.log(props)
        if (props.obtainedkey  !== state.key) {
            update.loading = false;
        }

        if (props.filteredHotspot.results  !== state.results) {
            update.results = props.filteredHotspot.results;
        }   

        if(props.filteredHotspot.csv !== state.csv){
            update.csv = props.filteredHotspot.csv; 
            if(props.filteredHotspot.csv.content !== "" && props.filteredHotspot.csv.content !== undefined)
            update.enableCsv = true;
        }

        if(props.userRoles.userRoles.length !== state.userRoles.userRoles.length){ 
            if(props.userRoles.userRoles.length === 0){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
            }
            if(!props.userRoles.success){
                props.history.push("/signIn"); 

            }
        }

        return update;
    }

    componentDidUpdate(prevProps, prevState, snapshot){
    }

    updateSnackbarStatus = (snackbarObject) => {
        this.setState({
            isSnackbarError: snackbarObject.isSnackbarError,
            isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
            snackbarErrorMessage: snackbarObject.ErrorMessage
        })
    }

    updateSnackbarStatusFalse = () => {
        if (this.state.isSwitchSnackbarOn) {
            this.setState({ isSwitchSnackbarOn: false })
        }
    }
    
    handleChange=(name)=>event =>{
        this.updateSnackbarStatusFalse(); 
        this.setState({[name]: event.target.value,
        contextChanged:true});
    }
  
    /*
    _handleSubmit = values => {
        this.handleModalClose();
        Object.assign(values, { id: this.state.id }, { keyword: '' }, { offset: this.setNewOffset(this.state.rowsPerPage, this.state.page) }, { limit: this.state.rowsPerPage });
        this.props.registerPackage(values, this.props.history);
    };
    handleModalOpen = (id, username) => {
        this.updateSnackbarStatusFalse();
        this.setState({
            id: id,
            username: username,
            open: true,
        });
    };

    handleModalClose = () => {
        this.setState({ open: false });
        this.props.reset();
    }; 
    handleActive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage);
    };

    handleInactive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoinactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage );
    };

    handleSelectAllClick = (event, checked) => {
        this.updateSnackbarStatusFalse();
        if (checked) {
            this.setState({ selected: this.state.users.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        this.updateSnackbarStatusFalse();
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(this.state.rowsPerPage, page), this.state.rowsPerPage);
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(event.target.value, this.state.page), event.target.value);
        this.setState({ rowsPerPage: event.target.value });
    };

    setNewOffset = (rowPerPage, page) => {
        return rowPerPage * page;
    }
                            <TextField
                                id="status"
                                label="Status" 
                                defaultValue={this.state.status} 
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={ this.handleChange('status')}
                            />
*/

handleCSVSearch = event => { 
    if(this.state.contextChanged){
        this.setState({ loading: true }); 
        var triggered = {
            dateFrom: this.state.dateFrom,
            dateTo: this.state.dateTo,
            status:this.state.status,
            type:this.state.type
        }
        this.updateSnackbarStatusFalse();   
       // this.setState({ searchVal: event.target.value })
       this.props.fetchTriggeredCSV(triggered);
        } 
     
};


    handleSearch = event => {
        if(this.state.contextChanged){
        this.setState({ loading: true }); 
        var triggered = {
            dateFrom: this.state.dateFrom,
            dateTo: this.state.dateTo,
            status:this.state.status,
            type:this.state.type
        }
        this.updateSnackbarStatusFalse();   
       // this.setState({ searchVal: event.target.value })
       this.props.fetchTriggered(triggered);
        }
    };

    handleDate = (name)  => event =>{
        let that = this;
        let e =event;
        console.log( this.state[name])
        if(e.target.value !== this.state[name]){
        that.setState({[name]: e.target.value,
            contextChanged:true});
        } 
    }
 

    render() {

        const { classes } = this.props;
        const { users, order, orderBy, selected, rowsPerPage, page, offset, isSwitchSnackbarOn, isSnackbarError,enableCsv,loading } = this.state;
      
        return (
            <MainWrapper
            history={this.props.history}
                isDisplayOn="none"
                userRoles={this.props.userRoles}>
          
                <Paper className={classes.root}>
                    <EnhancedTableToolbar
                        tableName='Filtered Data' 
                        numSelected={0}
                    />
                    <div className={classes.search}>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item>
                                <SearchIcon />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="dateFrom"
                                label="Date From"
                                type="date"
                                defaultValue={this.state.dateFrom}
                                InputLabelProps={{
                                shrink: true,
                                }} 
                                onChange={this.handleDate('dateFrom')}
                            />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="dateTo"
                                label="Date To"
                                type="date"
                                defaultValue={this.state.dateTo} 
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={ this.handleDate('dateTo')}
                            />
                            </Grid>
                            <Grid item>
                                <FormControl className={classes.formControl} style={{width:150}}>
                                    <InputLabel htmlFor="status">Status</InputLabel>
                            <Select
                                    value={this.state.status}
                                    onChange={this.handleChange('status')}
                                    name="status"
                                    inputProps={{
                                        id: 'status',
                                    }}
                                    className={classes.selectEmpty}
                                    >
                                    <MenuItem value="NEW">
                                        <em>NEW</em>
                                    </MenuItem>
                                    <MenuItem value="NOTIFIED">NOTIFIED</MenuItem> 
                                    <MenuItem value="UNATTENDED">UNATTENDED</MenuItem> 
                                    </Select>
                                </FormControl>

                            </Grid>


                            <Grid item style={{padding:'10px'}}>
                                <FormControl className={classes.formControl} style={{width:150}}>
                                    <InputLabel htmlFor="datatype">Data Source</InputLabel>
                                    <Select
                                    value={this.state.type}
                                    onChange={this.handleChange('type')}
                                    name="type"
                                    inputProps={{
                                        id: 'datatype',
                                    }}
                                    className={classes.selectEmpty}
                                    >
                                    <MenuItem value="MODIS">
                                        <em>MODIS</em>
                                    </MenuItem>
                                    <MenuItem value="VIIRS">VIIRS</MenuItem> 
                                    </Select>
                                    <FormHelperText></FormHelperText>
                                </FormControl>
                                
                            </Grid>
                            <Grid item>
                                <Button  variant="outlined"
                                onClick={(e) => this.handleSearch(e) } >Search</Button>
                            </Grid>
                            
                            <Grid item>
                        <Button  variant="outlined"
                                onClick={(e) => this.handleCSVSearch(e) } >Activate CSV</Button>
                                </Grid>
                                <Grid item>
                                    { enableCsv ? (
                                <CSVLink
                                    data={this.state.csv.content}
                                    filename={"filteredhotspot.csv"}
                                    className="btn btn-primary"
                                    target="_blank"
                                    >
                                    Download CSV
                                    </CSVLink>) : null}
                                </Grid>
                        </Grid>
                    </div>
                </Paper> 
                <Paper className={classes.root}>
                    <EnhancedTableToolbar
                        tableName='' 
                        numSelected={0}
                    />
                    <div className={classes.search}>
                        <TriggeredNotifyTable 
                            data={this.state.results} 
                        />
                    </div> 
                </Paper>
                    <NotificationSnackBar
                            isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
                            isSnackbarError={this.state.isSnackbarError}
                            snackbarErrorMessage={this.state.snackbarErrorMessage}
                    /> 
                {loading ? (
                <Grid container className={classes.root}>
                    <Grid item xs={12} style={{backgroundColor:'#333', }}>
                        <Grid container className={classes.loadingHeight} justify='center' alignItems='center'>
                            <CircularProgress color="primary" size={70} thickness={7} />
                        </Grid>
                    </Grid>
                </Grid>
            ) : null
            }
            </MainWrapper>
        );
    }
}

TriggeredNotifications.propTypes = {
    classes: PropTypes.object.isRequired,
};

function validate(values) {
    const errors = {};

    
    return errors;
}

let SignInWithStyles = withStyles(styles)(TriggeredNotifications);

SignInWithStyles = reduxForm({ 
    form: "triggeredNotifyForms"
})(SignInWithStyles);


  //    getNotExpiredPackages={this.props.notexpiredpackagesResult}>

const mapStateToProps = ({ userRoles,filteredHotspot }) => { 
    return {
        userRoles: userRoles,
        filteredHotspot:filteredHotspot,
        results:filteredHotspot.results,
        obtainedkey: filteredHotspot.key,
    };
};

export default connect(
    mapStateToProps,
    { fetchTriggered,checkUserRole,fetchTriggeredCSV}
)(SignInWithStyles);




// WEBPACK FOOTER //
// ./src/components/tabs/TriggeredNotifications.js